import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const listClubs = () =>
  axios.get(`${getV2RootUrl()}/club/for-web`, publicAxiosHeaderV2());

export const getClub = (slug) =>
  axios.get(
    `${getV2RootUrl()}/club/slug/${slug}/for-web`,
    publicAxiosHeaderV2()
  );

export const getClubItems = (shipmentId) => {
  const custId = customerId();
  return axios.get(
    `${getV2RootUrl()}/customer/${custId}/club/shipment/${shipmentId}/for-web`,
    publicAxiosHeaderV2()
  );
};

export const updateClubItems = (shipmentId, data) => {
  const custId = customerId();
  return axios.put(
    `${getV2RootUrl()}/customer/${custId}/club/shipment/${shipmentId}/for-web`,
    { items: data },
    publicAxiosHeaderV2()
  );
};
